import React, { useState, useEffect, useRef } from 'react';
import { Avatar, Typography } from "@material-ui/core";
import { KeyboardArrowRight } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { getInitials, getAvatarFontSize } from "~/utils/business";
import { handleAddress, getContrastColor } from '~/utils/business';

const BusinessHeader = ({
	business,
	onSeeMoreClick,
	showSeeMore = true,
	avatarSize = 72,
	titleFontSize = "clamp(26px, 2vw, 30px)",
	seeMoreFontSize = "clamp(16px, 1.5vw, 20px)",
	iconFontSize = "clamp(16px, 1.5vw, 20px)",
	textColor = "#fff",
	backgroundColor = "#8C1837",
	containerStyle = {},
	avatarStyle = {},
	titleStyle = {},
	seeMoreStyle = {},
	seeMore = true,
	viewAddress = true,
}) => {
	const { t } = useTranslation();
	const [showAddress, setShowAddress] = useState(true);
	const titleRef = useRef(null);
	const colorBackgroundStorage = sessionStorage.getItem('@prit/colorBackground');
	const colorTextContrast = colorBackgroundStorage && getContrastColor(colorBackgroundStorage);
	
	// Função para detectar se o título quebrou linha
	const detectTitleLineBreak = () => {
		if (!titleRef.current) return false;
		
		const element = titleRef.current;
		const computedStyle = window.getComputedStyle(element);
		const lineHeight = parseFloat(computedStyle.lineHeight);
		const elementHeight = element.offsetHeight;
		
		const hasLineBreak = elementHeight > lineHeight * 1.3;
		const isLongText = business?.name && business.name.length > 20;
		
		return hasLineBreak || isLongText;
	};

	useEffect(() => {
		if (business?.name) {
			const timer = setTimeout(() => {
				const hasLineBreak = detectTitleLineBreak();
				setShowAddress(!hasLineBreak);
			}, 100);
			return () => clearTimeout(timer);
		}
	}, [business?.name, titleFontSize]);

	useEffect(() => {
		const handleResize = () => {
			if (business?.name) {
				const timer = setTimeout(() => {
					const hasLineBreak = detectTitleLineBreak();
					setShowAddress(!hasLineBreak);
				}, 100);
				return () => clearTimeout(timer);
			}
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [business?.name, titleFontSize]);

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "end",
				height: colorBackgroundStorage ? "28vh" : "34vh",
				...containerStyle,
			}}
		>
			<div style={{ display: "flex", alignItems: "flex-end", gap: 10, marginBottom: 10 }}>
				<Avatar
					variant="circle"
					style={{
						height: `${avatarSize}px`,
						width: `${avatarSize}px`,
						alignSelf: "flex-end",
						backgroundColor: backgroundColor,
						...avatarStyle,
					}}
					src={business?.thumbnailUrl ? business.thumbnailUrl : ""}
				>
					<Typography style={{ fontSize: getAvatarFontSize(business?.name) }}>
						{business?.thumbnailUrl ? business.thumbnailUrl : getInitials(business?.name)}
					</Typography>
				</Avatar>
				<div style={{ display: "flex", flexDirection: "column" }}>
					<Typography
						ref={titleRef}
						style={{
							fontSize: titleFontSize,
							color: colorTextContrast || textColor,
							textShadow: !colorTextContrast && "2px 2px 4px rgba(0, 0, 0, 0.8), -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
							fontWeight: "bold",
							...titleStyle,
							lineHeight: '1.2',
							...(colorBackgroundStorage && {
								display: "-webkit-box",
								WebkitLineClamp: 2,
								WebkitBoxOrient: "vertical",
								overflow: "hidden",
							}),
						}}
					>
						{business?.name}
					</Typography>
					{showSeeMore && (
						<div
							style={{ 
								display: "flex", 
								alignItems: "center",
								cursor: "pointer",
								...seeMoreStyle 
							}}
						>
							<div style={{ 
								display: "flex",
								flexDirection: "column",
							 }}>
								{viewAddress && showAddress && (
									<Typography 
										style={{ 
											fontSize: seeMoreFontSize, 
											color: colorTextContrast || textColor,
											textShadow: !colorTextContrast && "2px 2px 4px rgba(0, 0, 0, 0.8), -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
											fontWeight: "normal",
										}}>
										{handleAddress(business, 30)}
									</Typography>
								)}
								{seeMore && (
									<>
										<div 
											style={{ display: "flex", alignItems: "center", gap: 2 }}
											onClick={onSeeMoreClick}
										>
											<Typography
												style={{ 
													fontSize: "clamp(14px, 1vw, 16px)", 
													color: colorTextContrast || "#CCCCCC",
													textShadow: !colorTextContrast && "2px 2px 4px rgba(0, 0, 0, 0.8), -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
													fontWeight: "normal",
													paddingTop: 1
												}}
											>
												{t("Learn more")}
											</Typography>
											<KeyboardArrowRight 
											style={{ 
												fontSize: iconFontSize, 
												color: colorTextContrast || "#CCCCCC",
												filter: !colorTextContrast && "drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.6)) drop-shadow(-0.5px -0.5px 0 rgba(0, 0, 0, 0.8)) drop-shadow(0.5px -0.5px 0 rgba(0, 0, 0, 0.8)) drop-shadow(-0.5px 0.5px 0 rgba(0, 0, 0, 0.8)) drop-shadow(0.5px 0.5px 0 rgba(0, 0, 0, 0.8))"
												}} 
											/>
										</div>
									</>
								)}
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default BusinessHeader; 